export default "__VITE_ASSET__CDiXr9xK__"